<script setup lang="ts">
// TODO: modules/ should not import anyting from outside or core/. Deal with this.
import { formatDistance } from '@libs/utils';

import type { Distance } from '../../models';

interface HotelDescriptionDistancesProps {
  distances: Distance[];
}

const props = defineProps<HotelDescriptionDistancesProps>();
</script>

<template>
  <div class="hotel-description-distances">
    <div class="title">
      {{ $t('planner.distances') }}
    </div>
    <div
      v-for="distance in props.distances"
      :key="distance.description"
      class="distance"
    >
      <div>{{ distance.description }}</div>
      <div>{{ formatDistance(distance.distanceMeters) }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.hotel-description-distances {
  margin-top: var(--spacing-32);

  .title {
    margin-bottom: var(--spacing-16);
    color: var(--color-secondary-40);
    @include font-heading-5;
  }

  .distance {
    display: flex;
    justify-content: space-between;
    @include font-body-m-light;
  }
}
</style>
